import React from 'react';
import Reveal from '../components/Reveal';
import { AndroidIcon, WindowsIcon } from '../components/Icons';
import { downloadCards } from '../data/siteData';

const iconMap = {
  blue: WindowsIcon,
  green: AndroidIcon
};

export default function DownloadsPage() {
  return (
    <section className="downloads-page page-section">
      <div className="container">
        <Reveal className="page-hero">
          <h1>Downloads</h1>
          <p>Baixe os produtos da Arco Tech Sistemas para sua plataforma.</p>
        </Reveal>

        <div className="download-grid">
          {downloadCards.map((card, index) => {
            const Icon = iconMap[card.tone] || WindowsIcon;

            return (
              <Reveal key={card.title} delay={index * 90} className="download-card">
                <Icon className={`platform-icon platform-icon--${card.tone}`} />
                <h2>{card.title}</h2>
                <p>{card.description}</p>
                <a
                  href={card.href}
                  className={`button button--${card.tone}`}
                  target={card.href.startsWith('http') ? '_blank' : undefined}
                  rel={card.href.startsWith('http') ? 'noreferrer' : undefined}
                  download={card.href.startsWith('http') ? undefined : true}
                >
                  {card.label}
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
